var exports = {
  "kL": "ChannelPermissionsTab.module__container___aTl4dE",
  "Ut": "ChannelPermissionsTab.module__syncBanner___aTl4dE",
  "iH": "ChannelPermissionsTab.module__syncBannerSynced___aTl4dE",
  "bT": "ChannelPermissionsTab.module__syncBannerUnsynced___aTl4dE",
  "Vg": "ChannelPermissionsTab.module__grid___aTl4dE",
  "s4": "ChannelPermissionsTab.module__leftTitle___aTl4dE",
  "pG": "ChannelPermissionsTab.module__right___aTl4dE",
  "ze": "ChannelPermissionsTab.module__rightScroller___aTl4dE",
  "CI": "ChannelPermissionsTab.module__sectionRow___aTl4dE",
  "bV": "ChannelPermissionsTab.module__sectionHeader___aTl4dE",
  "Gf": "ChannelPermissionsTab.module__sectionTitle___aTl4dE",
  "bQ": "ChannelPermissionsTab.module__subtleText___aTl4dE",
  "cy": "ChannelPermissionsTab.module__permHeaderRow___aTl4dE",
  "mA": "ChannelPermissionsTab.module__permHelp___aTl4dE",
  "p$": "ChannelPermissionsTab.module__emptyState___aTl4dE",
  "rV": "ChannelPermissionsTab.module__overwriteItem___aTl4dE",
  "w7": "ChannelPermissionsTab.module__overwriteItemSelected___aTl4dE",
  "Vd": "ChannelPermissionsTab.module__overwriteItemContextMenuOpen___aTl4dE",
  "FD": "ChannelPermissionsTab.module__overwriteIcon___aTl4dE",
  "m4": "ChannelPermissionsTab.module__roleDot___aTl4dE",
  "l": "ChannelPermissionsTab.module__overwriteName___aTl4dE",
  "Fs": "ChannelPermissionsTab.module__permSearchRow___aTl4dE",
  "XZ": "ChannelPermissionsTab.module__permSearchInput___aTl4dE",
  "sN": "ChannelPermissionsTab.module__layoutButtons___aTl4dE",
  "Zh": "ChannelPermissionsTab.module__layoutButton___aTl4dE",
  "HU": "ChannelPermissionsTab.module__permCategories___aTl4dE",
  "Fv": "ChannelPermissionsTab.module__mobileOverrideList___aTl4dE",
  "E_": "ChannelPermissionsTab.module__mobileListHeader___aTl4dE",
  "JJ": "ChannelPermissionsTab.module__mobileListTitle___aTl4dE",
  "_4": "ChannelPermissionsTab.module__mobileOverrides___aTl4dE",
  "Ud": "ChannelPermissionsTab.module__mobileOverrideItem___aTl4dE",
  "wP": "ChannelPermissionsTab.module__mobileOverrideName___aTl4dE",
  "wu": "ChannelPermissionsTab.module__mobileOverrideChevron___aTl4dE",
  "yg": "ChannelPermissionsTab.module__mobileBackRow___aTl4dE",
};

module.exports = exports;
